import _ from 'lodash';
import { useEffect } from 'react';
import { NEXT_PUBLIC_SPEED_KEYPOINT } from 'src/constants';
import { htmlToPlainText } from 'src/utils/helper';
import styled from 'styled-components';

function WidgetKeypoint({ isKeyPoint, article }) {
  // useEffect(() => {
  //   const keypointContent = document.getElementById('keypoint-content');
  //   while (keypointContent?.firstChild) {
  //     keypointContent?.removeChild(keypointContent?.firstChild);
  //   }

  //   if (isKeyPoint === true && !_.isEmpty(article?.key_point)) {
  //     const element = document.getElementById('feature-image');
  //     element?.scrollIntoView({ behavior: 'smooth', top: 0 });

  //     const div = document.createElement('div');
  //     div.innerHTML = article?.key_point || '';

  //     const strongElements = div.getElementsByTagName('strong');
  //     for (let i = 0; i < strongElements.length; i++) {
  //       strongElements[i].style.fontWeight = 'bold';
  //     }

  //     const speed = NEXT_PUBLIC_SPEED_KEYPOINT ?? 50;

  //     let txt = article?.key_point;
  //     let i = 0;
  //     // let div;

  //     txt = htmlToPlainText(txt?.replace(/<\/?[^>]+(>|$)/g, match => (match === '<li>' ? '_' : '')));

  //     const ul = document.createElement('ul');
  //     let li = document.createElement('div');

  //     const intervalId = setInterval(() => {
  //       if (i < txt.length) {
  //         const char = txt.charAt(i);
  //         if (char === '_') {
  //           keypointContent?.appendChild(ul);
  //           li = document.createElement('li');
  //           // Create a new li element for the next line
  //           keypointContent?.appendChild(li);
  //           ul.appendChild(li);
  //           i++;
  //         } else {
  //           li.innerHTML += char;
  //           i++;
  //         }
  //       }
  //       // else {
  //       //     clearInterval(intervalId);
  //       // }
  //     }, speed);

  //     return () => clearInterval(intervalId);
  //   }
  // }, [isKeyPoint]);
  return (
    <SectionWrapper className='keypoint-flex'>
      <div id='key-point' className={`keypoint-wrapper ${isKeyPoint ? 'dis' : 'hid'}`}>
        <h2
          className='hide-seo'
          dangerouslySetInnerHTML={{
            __html: `${article?.blurb || ''}`
          }}
        />

        <div className='keypoint-header'>
          <p>KEY POINTS</p>
        </div>
        <div
          id='keypoint-content'
          className='keypoint-lists'
          dangerouslySetInnerHTML={{
            __html: article.key_point ?? ''
          }}
        />
      </div>
    </SectionWrapper>
  );
}

export default WidgetKeypoint;

const SectionWrapper = styled.div`
  position: relative;
  background-color: var(--blockquote-color);
  border: 2px solid var(--quaternary-color);
  box-shadow: 0 0 5px 0 var(--quaternary-color);
  font-size: 14pt;
  font-weight: 400;
  line-height: 1.45;
  padding: 20px;
  margin: 30px 0;
  color: var(--secondary-blue);
  .keypoint-header {
    position: absolute;
    top: -15px;
    background: var(--primary-color);
    border-radius: 0px 10px 0px 10px;
    p {
      color: var(--white-color);
      padding: 2px 10px;
      font-size: 20px;
    }
  }

  ul {
    padding-left: 30px;
    line-height: 16px;
    margin: 10px 0 0 0;
    font-family: 'DBHelvethaicaXBd', sans-serif !important;
    li {
      display: flex;
      align-items: flex-start;
      font-family: 'Sarabun', sans-serif;
      ::marker {
        font-size: 24px;
        line-height: 0;
        color: var(--secondary-color);
      }
      list-style-type: disc;
      display: list-item;
      margin-left: 1.5rem;
      line-height: 1.45;
      font-weight: 600;
      font-size: 20px;
      margin: 0 0 15px 1.5rem;
      a {
        letter-spacing: 0.2px;
        font-display: swap;
      }
    }

    li:last-child {
      margin-bottom: 0;
    }

    @media (max-width: 767px) {
      padding: 0px;
      li {
        font-size: 20px;
        line-height: 1.55;
        /* margin-bottom: 10px; */
      }
    }
  }
`;
